export default __webpack_public_path__ + "static/media/TeraScannerRed.2594f4ef.svg";